var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "pc-basket-continue-checkout-modal",
      attrs: {
        width: "920",
        height: "auto",
        name: "pc-basket-continue-checkout-modal",
        "data-html2canvas-ignore": "true",
        adaptive: true,
        scrollable: false
      }
    },
    [
      _c(
        "div",
        { staticClass: "pc-basket-continue-checkout-modal-container" },
        [
          _c(
            "button",
            {
              staticClass:
                "continue-checkout-modal-button-close btn button-full",
              attrs: { type: "button" },
              on: { click: _vm.closeModal }
            },
            [
              _c("span", {
                staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
                attrs: { "aria-label": "Close modal" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pc-basket-continue-checkout-modal-wrapper" },
            [
              _c(
                "div",
                { staticClass: "pc-basket-continue-checkout-modal-header" },
                [
                  _c("div", { staticClass: "continue-checkout-modal-header" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString[
                            "myBasket.ContinueShipping.Modal.Title"
                          ]
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString[
                            "myBasket.ContinueShipping.Modal.Description"
                          ]
                        )
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pc-basket-continue-checkout-modal-body" },
                [
                  _vm.basketItems &&
                  _vm.basketItems.SiteItems &&
                  _vm.basketItems.SiteItems.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "pc-basket-continue-checkout-modal-list"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pc-basket-continue-checkout-modal-list-label"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.checkoutTypeOption,
                                    expression: "checkoutTypeOption"
                                  }
                                ],
                                staticClass:
                                  "continue-checkout-form-check-input",
                                attrs: {
                                  type: "radio",
                                  name: "continueCheckout",
                                  id: "individual-samples"
                                },
                                domProps: {
                                  value: _vm.site,
                                  checked: _vm._q(
                                    _vm.checkoutTypeOption,
                                    _vm.site
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.checkoutTypeOption = _vm.site
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "continue-checkout-form-check-label",
                                  attrs: { for: "individual-samples" }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "myBasket.Label.IndividualSamples"
                                        ]
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.basketItems.SiteItems.length || 0
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.basketItems &&
                  _vm.basketItems.ProjectItems &&
                  _vm.basketItems.ProjectItems.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "pc-basket-continue-checkout-modal-list"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pc-basket-continue-checkout-modal-list-label"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.checkoutTypeOption,
                                    expression: "checkoutTypeOption"
                                  }
                                ],
                                staticClass:
                                  "continue-checkout-form-check-input",
                                attrs: {
                                  type: "radio",
                                  name: "continueCheckout",
                                  id: "project-samples"
                                },
                                domProps: {
                                  value: _vm.project,
                                  checked: _vm._q(
                                    _vm.checkoutTypeOption,
                                    _vm.project
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.checkoutTypeOption = _vm.project
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "continue-checkout-form-check-label",
                                  attrs: { for: "project-samples" }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "myBasket.Label.ProjectSamples"
                                        ]
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.basketItems.ProjectItems.length || 0
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.basketItems &&
                  _vm.basketItems.TrayItems &&
                  _vm.basketItems.TrayItems.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "pc-basket-continue-checkout-modal-list"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pc-basket-continue-checkout-modal-list-label"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.checkoutTypeOption,
                                    expression: "checkoutTypeOption"
                                  }
                                ],
                                staticClass:
                                  "continue-checkout-form-check-input",
                                attrs: {
                                  type: "radio",
                                  name: "continueCheckout",
                                  id: "design-tray-samples"
                                },
                                domProps: {
                                  value: _vm.tray,
                                  checked: _vm._q(
                                    _vm.checkoutTypeOption,
                                    _vm.tray
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    _vm.checkoutTypeOption = _vm.tray
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "continue-checkout-form-check-label",
                                  attrs: { for: "design-tray-samples" }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "myBasket.Label.DesignTraySample"
                                        ]
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.basketItems.TrayItems.length || 0
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pc-basket-continue-checkout-modal-footer" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary next-btn",
                      attrs: {
                        type: "button",
                        disabled: !_vm.checkoutTypeOption
                      },
                      on: { click: _vm.continueToCheckOut }
                    },
                    [
                      _c("span", { staticClass: "btn-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$resourceString[
                              "myBasket.Button.ContinueToShipping"
                            ]
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "png-icon png-icon-icons-glyph--ko-arrow-next"
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }